<template>
    <div id="main">
		 <!-- <mt-header   :fixed="true" class="back" :title="title" v-if="isShow">
            <mt-button @click="goBack"  icon="back" slot="left"> 
                返回首页
            </mt-button>
        </mt-header> -->
        <vheader style="position:fixed;top:0;width:100%;z-index: 99;" v-if="isShow"></vheader>
        <!-- <keep-alive> -->
        <router-view  @changeTitle="changeTitle" :class="[isShow?'router_view':'']"></router-view>   
		<!-- </keep-alive> -->
        <mt-tabbar class="menu-color" v-model="selected" :fixed="fixed" v-if="isShow">
            <mt-tab-item id="/account" @click.native="jumpTo('/account')" v-if="show('account')">
                <img slot="icon" :src="account_icon"/>我的账户
            </mt-tab-item>
            <mt-tab-item id="/safe" @click.native="jumpTo('/safe')" v-if="show('safe')">
                <img slot="icon" :src="safe_icon"/>安全设置
            </mt-tab-item>
    
            <mt-tab-item id="/contract" @click.native="jumpTo('/contract')" v-if="show('contract')">
                <img slot="icon" :src="contract_icon">合作合同
            </mt-tab-item>
            <mt-tab-item id="/cooperation" @click.native="jumpTo('/cooperation')" v-if="show('cooperation')">
                <img slot="icon" :src="cooperation_icon"> 合作意向
            </mt-tab-item>
            <mt-tab-item id="/agent" @click.native="jumpTo('/agent')" v-if="show('agent')">
                <img slot="icon" :src="agent_icon"> 代理业务
            </mt-tab-item>
        </mt-tabbar>
    </div>
</template>

<script>
import url from "./config/url";
import { Toast, Indicator } from "mint-ui";
import account from "./status/images/icon/menu-icon/account.svg";
import accountSelected from "./status/images/icon/menu-icon/account-selected.png";
import safeSelected from "./status/images/icon/menu-icon/safe-selected.svg";
import contract from "./status/images/icon/menu-icon/contract.svg";
import cooperationSelected from "./status/images/icon/menu-icon/cooperation-selected.svg";
import cooperation from "./status/images/icon/menu-icon/cooperation.svg";
import agent from "./status/images/icon/menu-icon/agent.svg";
import vheader from "./components/header";
export default {
  data() {
    return {
      account_icon: accountSelected,
      safe_icon: safeSelected,
      contract_icon: contract,
      cooperation_icon: cooperationSelected,
      agent_icon: agent,
      selected: "/index",
      fixed: true,
      title: "",
      isShow: false
    };
  },
  components: {
    vheader
  },
  methods: {
    jumpTo: function(url) {
      this.$router.push(url);
    },
    goBack() {
      let ret = this.userService.getModel().getModel();
       let userRoles=this.userService.getModel().getData('userRoles');
      window.location.href =
        url.jumpurl +
        "?account=" +
        ret.account +"&userRoles"+userRoles
        "&permissions=" +
        ret.permissions +
        "&sessionId=" +
        ret.sessionid;
      // this.$router.go(-1);
    },
    changeTitle(title) {
      this.$data.title = title;
    },
    show(tab) {
      if (!this.userService.getModel().isLogin()) {
        return false;
      }
      let authorityList = this.userService.getModel().getData("authorityList");
      if (authorityList[tab].length > 0) {
        return true;
      }
      return false;
    },
    openTo(url, query) {
      this.$router.push({
        path: url,
        query
      });
      // const {href} = this.$router.resolve({
      //         path: url,
      //         query
      //       })
      // window.open(href, '_top')
    },
    checkTimeOut() {
      let out = 1500000;
      let now = new Date().valueOf();
      if(!this.userService.getModel().getModel().currentlogintime){
          return false;
      }
      let loginTime = new Date(
        this.userService.getModel().getModel().currentlogintime
      ).valueOf();
      let time = now - loginTime;
      if (time >= out) {
        Toast("登录已超时，请重新登录");
        this.userService.getModel().clear();
        setTimeout(() => {
          this.openTo("/login");
        }, 1000);
        return false;
      }
      return true;
    }
  },
  mounted() {
    window.localStorage["device"] = this.$route.query.device || "";
    if (/login|register|reward|protocol|activity|error/.test(this.$route.path)) {
        if(/login/.test(this.$route.path)&&this.userService.getModel().isLogin()){
            this.checkTimeOut();
        }
      this.isShow = false;
    } else {
      if (/share|message/.test(this.$route.path)) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
      if (!this.userService.getModel().isLogin()) {
        Toast("请登录!");
        Indicator.close();
        setTimeout(() => {
          this.openTo("/login");
        }, 1000);
        Indicator.close();
        return;
      }
      this.$data.selected = /^(\/[^\/]+)([\/]?.*)$/.exec(this.$route.path)[1];
      this.checkTimeOut();
    }
  },
  created() {
    this.wechatService.initWeiXin();
  },
  beforeRouteUpdate(to, from, next) {
    Indicator.close();
    if (/login|register|reward|protocol|activity|error/.test(to.path)) {
      this.isShow = false;
    } else {
      if (/share|message/.test(to.path)) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
      if (!this.userService.getModel().isLogin()) {
        Toast("请登录!");
        Indicator.close();
        setTimeout(() => {
          this.openTo("/login");
        }, 1000);
        Indicator.close();
        return;
      }
      this.$data.selected = /^(\/[^\/]+)([\/]?.*)$/.exec(to.path)[1];
      this.checkTimeOut();
    }
    next();
  }
};
</script>

<style lang="scss">
@import "./status/css/common.scss";
body{
  margin:0;
}
.router_view1 {
  padding-top: 1rem;
  padding-bottom: 1.4rem;
}
.router_view {
  padding-top: 1rem;
  padding-bottom: 1.4rem;
}
.mint-tabbar.menu-color {
  background: #fff;
}
.menu-color .mint-tab-item-label {
  color: #343434;
  font-size: 0.3rem;
  line-height: 0.3rem;
  height: 0.3rem;
}
.mint-tab-item-icon {
  width: 0.7rem;
  height: 0.7rem;
  margin: 0 auto 0.1rem;
}
.mint-tab-item {
  padding: 0.15rem 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  min-height: 100%;
}
body {
  margin: 0;
  padding: 0;
  border: 0;
  background: #f4f8fb;
}
p {
  margin: 0px;
}
input[type=button],input[type=text],input[type=password]{-webkit-appearance:none;outline:none}
body,
input,
button,
select,
textarea {
  font: 12px/1.5 "Microsoft Yahei", "Helvetica Neue", "iconfont";
  color: #34495e;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -moz-font-feature-settings: "liga", "kern";
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
img,
a img {
  border: 0;
}
a {
  color: #369;
  outline: medium none;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
label {
  cursor: pointer;
}
ul li {
  list-style: none;
}
em,
cite,
i {
  font-style: normal;
}
p {
  word-wrap: break-word;
  word-break: break-all;
} /*全部英文字符下自动换行*/

/* 去除Chrome等浏览器文本框默认发光边框 */
input:focus,
textarea:focus {
  outline: none;
}
/* 去除IE10+浏览器文本框后面的小叉叉 */
input::-ms-clear {
  display: none;
}
/* 禁止多行文本框textarea拖拽 */
textarea {
  resize: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue